<template>
    <ui-card icon="fal fa-cog" title="Configurações Gerais">
        <template #body>
            <div class="area-card">
                <transition name="small-fade">
                    <div v-show="loading" class="loading-card">
                        <ui-load-indicator bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8" />
                    </div>
                </transition>

                <div class="internal-header">
                    <h2 class="title">Quantidade de Reservas por Negócio.</h2>
                    <span class="desc"
                    >O usuário será notificado ao tentar realizar ou transferir uma reserva para um negócio com limite atingido.</span
                    >
                </div>

                <div class="select-container">
                    <div class="switch-container">
                        <div class="ui-switch">
                            <ui-switch
                                data-ui="configurations-reserves-deals"
                                v-model="configData.enabled"
                                design="xs"
                                :checked="configData.enabled"
                            />
                        </div>
                        Quantidade de Reservas por Negócio
                    </div>
                    <ui-input-number-stepper
                        v-model="configData.limit"
                        input-text-color="#2084E5"
                        data-ui="configurations-reserves-deals-quantity"
                        :disabled="!configData.enabled"
                    />
                </div>


            </div>
        </template>
        <template #fl/>
        <template #fr>
            <ui-button
                design="md success"
                data-ui="configurations-reserves-deals-save"
                :disabled="!canSubmit"
                :loading="loading"
                @click="submit">
                Salvar
            </ui-button>
        </template>
    </ui-card>
</template>
<script>
	import { uiLoadIndicator } from '@/components/ui'
    import { uiButton } from '@/components/ui/buttons'
    import { uiCard } from '@/components/ui/cards'
    import { uiInputNumberStepper, uiSwitch } from '@/components/ui/form'
    import { permissionsMixin } from '@/mixins'
    import { reserves } from '@/services/axios'


	export default {
		name: 'configuration-reserves-permissions',

        components: {
			uiCard,
			uiButton,
            uiSwitch,
            uiInputNumberStepper,
            uiLoadIndicator
		},

        mixins: [permissionsMixin],

		data() {
			return {
                loading: true,
                configData: {
                    enabled: false,
                    limit: 5
                },
                defaultForm: {
                    enabled: false,
                    limit: 5
                }
			}
		},

		computed: {
			canSubmit() {
                return JSON.stringify(this.defaultForm) !== JSON.stringify(this.configData) && (this.configData.limit !== "" && this.configData.limit !== 0);
			},


		},

        async created() {
            try {
                const { data } = await reserves.getConfigGlobal()

                this.configData = {
                    enabled: data.data.global_reserves_limit_deals.active,
                    limit: data.data.global_reserves_limit_deals.limit
                }

                this.defaultForm = JSON.parse(JSON.stringify(this.configData))
            } catch (error) {
                if (error.data && error.data.msg) this.$toastr.e(error)
            } finally {
                this.loading = false
            }
        },

		methods: {
            async submit() {
                if (this.loading) return;
				if (!this.$mx_userIsAdmin) {
                    return this.$toastr.e("Essa alterção só pode ser feita caso o usuário seja admininistrador")
                }
                this.loading = true;
                const payload = [{
                    name: "global_reserves_limit_deals",
                    active: this.configData.enabled,
                    value: {
                        limit: this.configData.limit
                    }
                }]

                await reserves.postConfigGlobal(payload)
                .then(() => {
                    this.$toastr.s("Permissões atualizadas com sucesso!")
                    this.defaultForm = {...this.configData}
                })
                .catch(error => {
                    if (error.data && error.data.msg) this.$toastr.e(error.data.msg)
                })
                .finally(() => {
                    this.loading = false;
                })
            }
		}
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
